import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  button:first-child {
    margin-bottom: 10px;
  }
`
